import { useEffect, useState } from "react";
import { FaSortDown, FaCircle } from "react-icons/fa6";
import "./Carousel.css";
import right_arrow from '../../resources/Frame 1000008597 (1).png'
import left_arrow from '../../resources/Frame 1000008597 (2).png'

function Carousel({ array, padding, disable_nav_button, auto_slide, interval, onIndexChange, button_color, max_width, hide_index, buttonClick, setButtonClick }) {
    const [displayIndex, setDisplayIndex] = useState(0)
    const array_length = array?.length

    useEffect(() => {
        if (buttonClick) {
            if (buttonClick == 1)
                if (displayIndex < (array_length - 1))
                    setDisplayIndex(displayIndex + 1)
                else
                    setDisplayIndex(0) // Loop back to the first item if at the end
            else if (buttonClick == -1)
                if (displayIndex > 0)
                    setDisplayIndex(displayIndex - 1)
                else
                    setDisplayIndex(array_length - 1) // Loop back to the last item if at the start

            setButtonClick(null)
        }
    }, [buttonClick])

    useEffect(() => {
        if (onIndexChange)
            onIndexChange(displayIndex)
    }, [displayIndex, onIndexChange]);

    useEffect(() => {
        const interval_fun = setInterval(() => {
            if (auto_slide)
                myFunction();
        }, interval ? interval : 10000);

        // Cleanup the interval on component unmount
        return () => clearInterval(interval_fun);
    }, [displayIndex, array])

    const myFunction = () => {
        if (array_length) {
            const ind = displayIndex + 1
            if (displayIndex < (array_length - 1))
                setDisplayIndex(ind)
            else
                setDisplayIndex(0)
        }
    };

    const canGoPrevious = displayIndex > 0;
    const canGoNext = displayIndex < (array_length - 1);

    return (
        <div className="font_family" style={{ width: max_width ? '100%' : '' }}>
            <div className="carousel_main_div">

                <div className={`carousel_main_arrow_div ${canGoPrevious ? 'cursor_pointer' : 'carousel_arrow_disabled'}`}
                    style={{ display: disable_nav_button ? 'none' : '' }}
                    onClick={() => {
                        if (canGoPrevious)
                            setDisplayIndex(displayIndex - 1)
                    }}>
                    <img src={left_arrow} className="carousel_main_arrow_img" />
                </div>
                {array?.map((component, i) => (
                    <div key={i} className={(displayIndex === i ? "carousel_indiv_div_display" : "carousel_indiv_div_hide") + (padding ? ' carousel_indiv_div_padding' : '')}>
                        {component}
                    </div>
                ))}
                <div className={`carousel_main_arrow_div ${canGoNext ? 'cursor_pointer' : 'carousel_arrow_disabled'}`}
                    style={{ display: disable_nav_button ? 'none' : '' }}
                    onClick={() => {
                        if (canGoNext)
                            setDisplayIndex(displayIndex + 1)
                    }}>
                    <img src={right_arrow} className="carousel_main_arrow_img" />
                </div>
            </div>
            {hide_index ? null :
                <div className="carousel_tracker_circles">
                    {array?.map((component, i) => (
                        <div onClick={() => setDisplayIndex(i)} key={i}>
                            <FaCircle color={displayIndex === i ? "#5D7DCD" : '#A7B0C4'} size={8} />
                        </div>
                    ))}
                </div>
            }
        </div>
    );
}

export default Carousel;